import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark bg-dark" };
const _hoisted_2 = { class: "container-fluid" };
const _hoisted_3 = {
    class: "navbar-brand",
    href: "/"
};
const _hoisted_4 = { class: "collapse navbar-collapse" };
const _hoisted_5 = {
    key: 0,
    class: "navbar-nav"
};
const _hoisted_6 = {
    key: 0,
    class: "nav-item"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
    key: 1,
    class: "nav-item dropdown"
};
const _hoisted_9 = ["id"];
const _hoisted_10 = ["aria-labelledby"];
const _hoisted_11 = { key: 0 };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("hr", { class: "dropdown-divider" }, null, -1);
const _hoisted_13 = [
    _hoisted_12
];
const _hoisted_14 = ["src"];
const _hoisted_15 = { class: "collapse navbar-collapse justify-content-end" };
const _hoisted_16 = { class: "navbar-nav" };
const _hoisted_17 = { class: "nav-item dropdown" };
const _hoisted_18 = {
    class: "nav-link dropdown-toggle",
    href: "#",
    id: "nav-system__user",
    role: "button",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
};
const _hoisted_19 = {
    class: "dropdown-menu",
    "aria-labelledby": "nav-system__user"
};
const _hoisted_20 = /*#__PURE__*/ _createTextVNode(" Meine Claims ");
const _hoisted_21 = /*#__PURE__*/ _createTextVNode(" Cache ");
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        class: "nav-link",
        href: "/logout"
    }, "Abmelden")
], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$host.config.title), 1),
            _createElementVNode("div", _hoisted_4, [
                (_ctx.mainMenuEntriesLeft && _ctx.mainMenuEntriesLeft.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainMenuEntriesLeft, (menuItem) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (!menuItem.children || menuItem.children.length === 0)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                                        _createVNode(_component_g_link, {
                                            src: menuItem.actionCommand,
                                            target: menuItem.actionTarget,
                                            class: "nav-link"
                                        }, {
                                            default: _withCtx(() => [
                                                (menuItem.iconUrl)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: menuItem.iconUrl
                                                    }, null, 8, _hoisted_7))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(" " + _toDisplayString(menuItem.caption), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["src", "target"])
                                    ]))
                                    : (_openBlock(), _createElementBlock("li", _hoisted_8, [
                                        _createElementVNode("a", {
                                            class: "nav-link dropdown-toggle",
                                            href: "#",
                                            id: 'navbarDropdown_' + menuItem.menuID,
                                            role: "button",
                                            "data-bs-toggle": "dropdown",
                                            "aria-expanded": "false"
                                        }, _toDisplayString(menuItem.caption), 9, _hoisted_9),
                                        _createElementVNode("ul", {
                                            class: "dropdown-menu",
                                            "aria-labelledby": 'navbarDropdown_' + menuItem.menuID
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.children, (subMenuItem) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                    (subMenuItem.beginGroup)
                                                        ? (_openBlock(), _createElementBlock("li", _hoisted_11, _hoisted_13))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("li", null, [
                                                        _createVNode(_component_g_link, {
                                                            src: subMenuItem.actionCommand,
                                                            target: subMenuItem.actionTarget,
                                                            class: "dropdown-item",
                                                            "default-class": ""
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (subMenuItem.iconUrl)
                                                                    ? (_openBlock(), _createElementBlock("img", {
                                                                        key: 0,
                                                                        src: subMenuItem.iconUrl
                                                                    }, null, 8, _hoisted_14))
                                                                    : _createCommentVNode("", true),
                                                                _createTextVNode(" " + _toDisplayString(subMenuItem.caption), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["src", "target"])
                                                    ])
                                                ], 64));
                                            }), 256))
                                        ], 8, _hoisted_10)
                                    ]))
                            ], 64));
                        }), 256))
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
                _createElementVNode("ul", _hoisted_16, [
                    _createElementVNode("li", _hoisted_17, [
                        _createElementVNode("a", _hoisted_18, " Hallo " + _toDisplayString(_ctx.userDisplayName), 1),
                        _createElementVNode("ul", _hoisted_19, [
                            _createElementVNode("li", null, [
                                _createVNode(_component_g_link, {
                                    src: "to:///adm/user/claims",
                                    class: "dropdown-item",
                                    "default-class": ""
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_20
                                    ]),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("li", null, [
                                _createVNode(_component_g_link, {
                                    src: "to:///adm/system/cache",
                                    class: "dropdown-item",
                                    "default-class": ""
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_21
                                    ]),
                                    _: 1
                                })
                            ])
                        ])
                    ]),
                    _hoisted_22
                ])
            ])
        ])
    ]));
}
